<template>
    <div class="md:m-0 h-full flex-1 overflow-hidden">
        <!--<div id="wmksContainer"	style="position:absolute;width:100%;height:100%"></div>-->
        <div v-if="loading">
            <div class="flex items-center">
                <app-spinner class="text-gray-500" /> <span class="ml-3">Loading...</span>
            </div>
        </div>
        <div v-else>
            <div class="flex">
                <table>
                    <tr>
                        <td>Power State: </td>
                        <td>
                            <span v-if="vm.vm.power_state == 'POWERED_ON'" class="bg-green-300 text-green-700 text-xs px-2 py-1 rounded shadow mb-1 inline-block">ON</span>
                            <span v-if="vm.vm.power_state == 'POWERED_OFF'" class="bg-red-300 text-red-700 text-xs px-2 py-1 rounded shadow mb-1 inline-block">OFF</span>
                        </td>
                    </tr>
                    <tr v-if="vm.identity.full_name">
                        <td>Guest OS:</td>
                        <td>{{ vm.identity.full_name.default_message }}</td>
                    </tr>
                    <tr>
                        <td>DNS Name:</td>
                        <td>{{ vm.identity.host_name }}</td>
                    </tr>
                    <tr>
                        <td class="pr-3">IP Addresses: </td>
                        <td>{{ vm.identity.ip_address }}</td>
                    </tr>
                </table>
            </div>
            <div class="flex items-center mt-5">
                <app-button 
                    v-if="vm.vm.power_state == 'POWERED_OFF'"
                    class="btn-green mr-2"
                    :loading="turningOn"
                    @click="turnOn"
                >Turn on</app-button>
                <div v-if="vm.vm.power_state == 'POWERED_ON'">
                    <app-button 
                        class="btn-red"
                        :disable="restarting"
                        :loading="turningOff"
                        @click="turnOff"
                    >Turn off</app-button>
                    <app-button 
                        class="btn-white ml-2"
                        :disable="turningOff"
                        :loading="restarting"
                        @click="restart"
                    >Restart</app-button>
                </div>
            </div>
            <div class="mt-5">
                <div class="card">
                    <div class="card-header">VM Hardware</div>
                    <div class="card-body">
                        <table class="table">
                            <tr>
                                <td>CPU</td>
                                <td>{{ vm.vm.cpu.count }} CPU(s)</td>
                            </tr>
                            <tr>
                                <td>Memory</td>
                                <td>{{ vm.vm.memory.size_MiB / 1024 }} GB</td>
                            </tr>
                            <tr 
                                v-for="disk in vm.vm.disks"
                                :key="disk.key"
                            >
                                <td>{{ disk.value.label }}</td>
                                <td>{{ disk.value.capacity / (1024 * 1024 * 1024) }} GB</td>
                            </tr>
                            <tr 
                                v-for="nic in vm.vm.nics"
                                :key="nic.key"
                            >
                                <td>{{ nic.value.label }}</td>
                                <td>{{ nic.value.backing.network }} ({{ nic.value.state.toLowerCase() }})</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Http from '@/helpers/Http';    
    import WMKS from '@/wmks.min.js';
    import '@/css/vmware/wmks-all.css';

    export default {
        data() {
            return {
                loading: false,
                turningOn: false,
                turningOff: false,
                restarting: false,
                vm: {
                    identity: {
                        full_name: {}
                    },
                    vm: {
                        cpu: {},
                        memory: {},
                    },
                }
            }
        },
        watch: {
            $route: {
                handler() {
                    this.init();
                },
                deep: true,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.loading = true;
                Http.get(`vmware/vcenter/virtual_machine/${this.$route.meta.vm}`)
                    .then(({data}) => {
                        this.loading = false;
                        this.vm = data;

                        // const wmks = WMKS.createWMKS("wmksContainer", {})
                        //                .register(WMKS.CONST.Events.CONNECTION_STATE_CHANGE, function(event, data) {	
                        //                     console.log(event, data);
                        //                     if(data.state == cons.ConnectionState.CONNECTED) {	
                        //                         console.log("connection	state change: connected");
                        //                     }
                        //                 });
                                        
                        // wmks.connect("ws://10.1.1.139:8085");	
                    })
                    .catch(({response}) => {
                        this.loading = false;
                    });
            },
            turnOn() {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to turn on "<strong>${this.vm.vm.name}</strong>" virtual machine.`,
                    showCancelButton: true,
                    confirmButtonColor: '#48bb78',
                    confirmButtonText: 'Yes, turn it on!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return Http.post(`vmware/vcenter/virtual_machine/${this.$route.meta.vm}/turn_on`);
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.init();
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Virtual machine was successfully turned on.'
                        })
                    }
                })
            },
            turnOff() {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to turn off "<strong>${this.vm.vm.name}</strong>" virtual machine.`,
                    showCancelButton: true,
                    confirmButtonColor: '#f56565',
                    confirmButtonText: 'Yes, turn it off!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return Http.post(`vmware/vcenter/virtual_machine/${this.$route.meta.vm}/turn_off`);
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.init();
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Virtual machine was successfully turned off.'
                        })
                    }
                })
            },
            restart() {
                this.$swal.fire({
                    type: 'warning',
                    title: 'Are you sure?',
                    html: `You are about to restart "<strong>${this.vm.vm.name}</strong>" virtual machine.`,
                    showCancelButton: true,
                    confirmButtonColor: '#f56565',
                    confirmButtonText: 'Yes, restart it!',
                    showLoaderOnConfirm: true,
                    preConfirm: (response) => {
                        return Http.post(`vmware/vcenter/virtual_machine/${this.$route.meta.vm}/restart`);
                    },
                    allowOutsideClick: () => !this.$swal.isLoading()
                })
                .then((result) => {
                    if (result.value) {
                        this.init();
                        this.$swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Virtual machine was successfully restarted.'
                        })
                    }
                })
            }

        }
    }
</script>